// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/der-back-check-mit-der-aok-bayern/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const derBackCheckMitDerAokBayernDE: PageEntry = {
  id: "post.der-back-check-mit-der-aok-bayern",
  locale: "de",
  slug: "der-back-check-mit-der-aok-bayern",
  seo: {
    title: "Der BACK-CHECK mit der AOK Bayern | Dietz GmbH",
    description: "Der BACK-CHECK mit der AOK Bayern",
  },
  type: "post",
  h1: "Der BACK-CHECK mit der AOK Bayern",
  blocks: [
    { kind: "heading", level: 2, text: "Der BACK-CHECK mit der AOK Bayern" },
    { kind: "paragraph", text: "Im Rahmen des Kooperationsprogramms mit der AOK Bayern fand am 27. und 28. Oktober das nächste Aktionsangebot statt. ➡️ Allen Mitarbeitern wurde die Möglichkeit einer kostenlosen Kraftmessung zur Analyse der Kraftfähigkeit unterschiedlicher Muskelgruppen angeboten." },
    { kind: "paragraph", text: "Die Vorteile: Einseitige Belastungen sind oft der Grund für muskuläre Dysbalancen. Der Test deckte individuelle Stärken und Schwächen auf. Ausdruck mit individuellen Ergebnissen und Trainingsempfehlungen." },
    { kind: "paragraph", text: "Die Messung dauerte etwa 20 Minuten und wurde direkt vor Ort in unserem Sanitätsraum durchgeführt." },
    { kind: "paragraph", text: "Vielen Dank AOK Bayern!" }
  ],
};
